import { useEffect } from "react";
import { Alert } from "flowbite-react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { hideNotification } from "../../actions/notification";

const allowedColors = ["info", "success", "warning", "failure"];

function GlobalAlert() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { visible, message, color, title, duration, actionLabel, actionTo } =
    useSelector(
    (state) => state.notification
  );

  useEffect(() => {
    if (!visible) return;

    const timer = setTimeout(() => {
      dispatch(hideNotification());
    }, duration || 4500);

    return () => clearTimeout(timer);
  }, [visible, duration, dispatch]);

  if (!visible || !message) return null;

  const resolvedColor = allowedColors.includes(color) ? color : "info";

  return (
    <div className="fixed top-4 right-4 z-[1000] w-[calc(100%-2rem)] max-w-md">
      <Alert color={resolvedColor} onDismiss={() => dispatch(hideNotification())}>
        <div className="space-y-3">
          <div>
            {title ? <span className="font-semibold mr-1">{title}</span> : null}
            <span>{message}</span>
          </div>
          {actionLabel && actionTo ? (
            <button
              type="button"
              className="inline-flex items-center rounded-md bg-gray-900 px-3 py-1.5 text-sm font-medium text-white hover:bg-black focus:outline-none"
              onClick={() => {
                navigate(actionTo);
                dispatch(hideNotification());
              }}
            >
              {actionLabel}
            </button>
          ) : null}
        </div>
      </Alert>
    </div>
  );
}

export default GlobalAlert;
